import React, { Component } from "react";
import "babel-polyfill";
import AliBar from "./components/alibar";
import SearchCategory from "./components/searchCompoent";
import "../../scss/index.scss";
import offerModule from "../../module/index";
import headModule from "../../module/header";
import guuessModule from "../../module/guess";
import mkcModule from "../../module/mkc";
//import FooterModule from "./components/footer";
import FooterModule from "./newComponents/footer";
import service, { sendWW, getAIData } from "../../service/index";
import $ from "jquery";
import goldlog from "@ali/goldlog";
import { Feedback } from "@alife/next";
import Newheader from "./newComponents/header";
// import SearchCategorySticky from "./newComponents/searchCompoentSticky";
// import ZrList from "./components/zrList";
import SmartUIList from "./components/smartUIList";
import NewV3UIList from "./components/newV3UIList";
import ZrGuess from "./components/zrGuess";
import { loadJs } from "../util/loadJs";
import SEMPINZ from "./components/sempinz";
import { registerModule, registerService, start } from "@alife/tarot";
import { getUrlParam, getCookie } from "../util/common";
import Sidebar from "./components/sidebar";
// import SEMPINZ from "@alife/ocms-fusion-1688-pc-cate1688-pc-widget";

const Toast = Feedback.toast;

const getExpParams = (exp) => {
  let res = {};
  let configs = exp.split(";");
  configs.map((configStr) => {
    let key = configStr.split(":")[0];
    let val = configStr.split(":")[1];
    res[key] = val;
  });
  return res;
};

// JSTracker
window.g_config = window.g_config || {};
window.g_config.jstracker2 = window.g_config.jstracker2 || {};
window.g_config.jstracker2.pid = "24416-tracker";
Object.assign(window.g_config.jstracker2, { p_sampling: 100 });
loadJs(`//g.alicdn.com/tb/tracker/index.js`);

// 旺旺
loadJs(`https://g.alicdn.com/aliww/ww-light-cbu/index.js?t=${Date.now()}`);

//
loadJs(
  `https://g.alicdn.com/??/AWSC/AWSC/awsc.js,/sd/baxia-entry/baxiaCommon.js`
);

class Main extends Component {
  state = {
    width: 1190,
    visibleTopBar: false,
  };

  constructor(opts) {
    super(opts);

    this.receviceMessage = this.receviceMessage.bind(this);

    this.state = {
      showPz: true,
      aiData: {},
    };
  }

  async componentDidMount() {
    const self = this;
    const sizeFun = function () {
      const _width = document.body.clientWidth;
      if (_width < 1190) {
        self.setState({
          width: 990,
        });
      } else if (_width >= 1190 && _width < 1390) {
        self.setState({
          width: 1190,
        });
      } else {
        self.setState({
          width: 1390,
        });
      }
    };
    sizeFun();
    window.onresize = function () {
      let res;
      if (res) {
        clearTimeout(res);
      }
      res = setTimeout(() => {
        sizeFun();
      }, 20);
    };
    //滚动
    const sizeFun2 = function () {
      const _height = $(window).scrollTop();
      if (_height > 200) {
        if (!self.state.visibleTopBar) {
          self.setState((preState) => ({
            ...preState,
            visibleTopBar: true,
          }));
        }
      } else {
        if (self.state.visibleTopBar) {
          self.setState((preState) => ({
            ...preState,
            visibleTopBar: false,
          }));
        }
      }
    };
    $(window).scroll(() => {
      sizeFun2();
    });
    //配置
    window.__WPO.setConfig({
      sample: 1, // 抽样率，100 = 1%，1 = 100%，默认100
    });

    window.__WPO.log(`referrer_${p4pObject.cosite}`, 1);
    goldlog.record(
      "/szyx.pc_sem.referrer",
      "EXP",
      `ref=${p4pObject.cosite}`,
      "GET"
    );

    if (pageConfig.listOffer.length === 0) {
      const ref =
        document.referrer.indexOf(window.location.host) === -1
          ? "external"
          : "location";
      window.__WPO.log(
        `empty_${pageConfig.keywords}_${p4pObject.cosite}_${p4pObject.cosite}`,
        1
      );
      goldlog.record(
        "/szyx.pc_sem.empty",
        "EXP",
        `souce=${p4pObject.cosite}&ref=${ref}&keyword=${pageConfig.keywords}`,
        "GET"
      );
    }

    //
    window.addEventListener("message", this.receviceMessage, false);

    //pmp自动发旺旺
    const { exp } = pageConfig;
    const expParams = getExpParams(exp || "");
    const pmpFlag = getUrlParam("m_type") == 1;
    if (pmpFlag && getCookie("__cn_logon_id__") && expParams.pmpww == "B") {
      const { listOffer } = pageConfig;
      const firstOffer = listOffer[0];
      const eurl = firstOffer.eurl;
      const itemId = firstOffer.offerid;
      if (eurl.includes("dj.1688.com")) {
        sendWW(eurl, itemId, "_360_pcpmp");
      }
    }

    //get ai data
    if (expParams.asst == "B") {
      let aiData = await getAIData();
      //console.log('getaidata', aiData);
      aiData.type = "aiCard";
      this.setState({
        aiData,
      });
    }

    this.setupObserver();
  }

  //询盘语料实曝光
  setupObserver() {
    try {
      var targetElement = document.getElementsByClassName("ai-container")[0];
      let aiCardRecord = false;

      this.observer = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            !aiCardRecord &&
              window &&
              window.goldlog.record(
                "/ifission.ifission.pcSemAiExpTruly",
                "EXP"
              );
            aiCardRecord = true;
          }
        });
      });

      if (targetElement) {
        this.observer.observe(targetElement);
      }
    } catch (error) {
      console.log(error);
    }
  }

  receviceMessage(e) {
    try {
      const { type, action } = e.data;
      if (type === "ds_creative" && action === "remove") {
        this.setState({
          showPz: false,
        });
      }
    } catch (err) {
      console.error(err);
      this.setState({
        showPz: false,
      });
    }
  }

  firstFumianOffer() {
    const { listOffer, exp, fumianOffer = [] } = pageConfig;
    const newArr = [];
    const expParams = getExpParams(exp || "");
    // 过滤后的listOffer
    const pureList = listOffer.filter((item) => !!item.subject || !!item.title);
    // 过滤后的fumianOffer
    const pureFumianList = fumianOffer
      .filter((item) => !!item.subject || !!item.title)
      .slice(0, 6);
    const pushArr = (num) => {
      newArr.push(...pureList.slice(0, num));
      newArr.push(...pureFumianList);
      newArr.push(...pureList.slice(num));
    };
    if (expParams.pcSemFumian === "B") {
      pushArr(0);
      return newArr;
    } else if (expParams.pcSemFumian === "D") {
      pushArr(6);
      return newArr;
    } else if (expParams.pcSemFumian === "E") {
      pushArr(18);
      return newArr;
    }
    return pureList;
  }

  render() {
    const list = pageConfig.relativeWords || [];
    const listJSON = list;
    const { listOffer, exp, fumianOffer = [] } = pageConfig;
    const buyerTags = p4pObject.buyerTags || [];
    const expParams = getExpParams(exp || "");
    // const fumianList = [
    //   ...pureFumianList,
    //   ...pureList
    //     .filter((i) => !arr.includes(i.offerId))
    //     .slice(0, 20 - pureFumianList.length),
    // ];
    const fumianList = this.firstFumianOffer();

    return (
      <div className="app" id="app">
        <div>
          <AliBar width={this.state.width} />
          <Newheader width={this.state.width} />
          {this.state.showPz &&
          !["D", "E", "F", "H"].includes(expParams.qztf) ? (
            <SEMPINZ width={this.state.width} />
          ) : (
            ""
          )}
          <SearchCategory list={listJSON} width={this.state.width} />
          {["D", "E", "F", "H"].includes(expParams.qztf) ? (
            <NewV3UIList
              aiData={this.state.aiData}
              width={this.state.width}
              listOffer={fumianList}
              buyerTags={buyerTags}
            />
          ) : (
            <SmartUIList
              width={this.state.width}
              listOffer={fumianList}
              buyerTags={buyerTags}
            />
          )}
          {/*<SmartUIList width={this.state.width} listOffer={listOffer} buyerTags={buyerTags} />*/}
          {/* <NewV3UIList width={this.state.width} buyerTags={buyerTags} /> */}
          <ZrGuess width={this.state.width} />
          <Sidebar />
          <FooterModule width={this.state.width} />
        </div>
      </div>
    );
  }
}

registerService(service);
// 注册公共module
registerModule([offerModule, headModule, guuessModule, mkcModule]);

start("app", {
  root: <Main />,
  puck: {
    schema: {
      // 判断业务上是否成功
      isSuccess(res) {
        if (res.info && !res.info.ok) {
          const { code } = res.info;
          switch (code) {
            default:
              Toast.error(res.info.message || "服务器响应失败,请稍后再试!");
              break;
          }
        } else if (res.info && res.info.ok) {
          return true;
        } else {
          return false;
        }
      },
      // 获取数据
      getData(res) {
        return res.data;
      },
    },
  },
});
